export function createCalculationWorker() {
  return new Worker(new URL('./calculation.worker.js', import.meta.url), { name: 'qms-test-runtime' });
}
